<script lang="ts">
	import Checkmark from '$lib/icons/checkmark.svelte';
	import StarRating from '$lib/review/starRating.svelte';
	import type { Review } from '$lib/types/yotpo';

	interface Props {
		review: Review;
	}

	let { review }: Props = $props();
</script>

<div
	class="scrollbar-hide flex aspect-square max-h-[500px] select-none flex-col justify-between overflow-scroll rounded-2xl bg-stone-4 px-5 py-7 text-brown-2"
>
	<div>
		<StarRating starClass="h-7 w-7" score={review.score} />

		<p class="mt-3 flex -translate-x-[6px] text-[16px]/[140%]">
			<span>“</span>
			<span>
				{@html review.content}”
			</span>
		</p>
	</div>

	<div class="mt-4 flex gap-x-2">
		<div
			class="relative flex h-9 w-9 items-center justify-center rounded-full bg-orange-4 text-stone-4"
		>
			{review.user.display_name.charAt(0)}

			<div
				class="absolute bottom-0 right-0 flex h-5 w-5 translate-x-1 translate-y-1 items-center justify-center rounded-full border border-stone-5 bg-green-3"
			>
				<Checkmark class="h-3 w-3" />
			</div>
		</div>

		<div>
			<p class="font-serif text-[16px]/[140%]">{review.user.display_name}</p>
			{#if review.verified_buyer}
				<p class="text-[14px]/[140%] text-stone-1">Verified buyer</p>
			{/if}
		</div>
	</div>
</div>
